import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import ElementPlus from "element-plus"; // Import Element Plus
import "element-plus/dist/index.css"; // Element Plus styles
import apiClient from "@/plugins/axios"; // Import the Axios instance



import { useUserStore } from "@/stores/user";

// Silencia o erro benigno "ResizeObserver loop ..." (Element Plus) para que
// ele não dispare o overlay de erro do dev-server nem polua o console.
const ignoreResizeObserverError = (e) => {
  const msg = e && (e.message || (e.reason && e.reason.message)) ? (e.message || e.reason.message) : "";
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation && e.stopImmediatePropagation();
  }
};
window.addEventListener("error", ignoreResizeObserverError);

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(ElementPlus);

const userStore = useUserStore();
userStore.checkAuth(); // Check authentication on app startup
app.config.globalProperties.$api = apiClient;

app.mount("#app");
